import React from "react";
import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import "./style.scss";

const PRZButton = ({
  type,
  variant,
  color,
  size = "middle",
  onClick,
  children,
  className,
  isLoading,
  disabled,
  wrapperStyle,
  buttonStyle,
  ...rest
}) => {
  return (
    <div className="prz-button__wrapper" style={wrapperStyle}>
      <Button
        type={type}
        variant={variant}
        color={color}
        size={size}
        onClick={onClick}
        {...rest}
        className={`${className} custom-button`}
        style={buttonStyle}
        disabled={disabled}
      >
        {isLoading === true ? (
          <LoadingOutlined
            style={{ fontSize: "20px", marginTop: "-5px", color: type === 'default' ? "#2d7df7" :"white" }}
          />
        ) : (
          children
        )}
      </Button>
    </div>
  );
};

// Prop Types for validation
PRZButton.propTypes = {
  type: PropTypes.oneOf([
    "primary",
    "ghost",
    "dashed",
    "link",
    "text",
    "default",
  ]),
  size: PropTypes.oneOf(["small", "middle", "large"]),
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

// Default Props
PRZButton.defaultProps = {
  type: "primary",
  size: "middle",
  onClick: () => {},
};

export default PRZButton;
